import { render, staticRenderFns } from "./Etsy.vue?vue&type=template&id=145f0f68&scoped=true"
import script from "./Etsy.vue?vue&type=script&lang=js"
export * from "./Etsy.vue?vue&type=script&lang=js"
import style0 from "./Etsy.vue?vue&type=style&index=0&id=145f0f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145f0f68",
  null
  
)

export default component.exports